"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var navigation_1 = __importDefault(require("../navigation"));
// Delegate to new navigation script for backwards compatibility
var GreedyNav = {
    init: function (_options) {
        if (_options === void 0) { _options = {}; }
        console.warn('Deprecated: use initNavigation instead');
        (0, navigation_1.default)();
    },
};
exports.default = GreedyNav;
